import { Info as InfoIcon } from '@mui/icons-material';

interface ReturnStatusBadgeProps {
  ready: boolean;
  text: string;
}

const ReturnStatusBadge = ({ ready, text }: ReturnStatusBadgeProps) => {
  return (
    <div
      className={`hidden lg:flex items-center gap-2 px-4 py-2 rounded-2xl border ${
        ready
          ? 'bg-orange-50/50 border-orange-100 text-orange-700'
          : 'bg-gray-50 border-gray-100 text-gray-400'
      }`}
    >
      {ready ? (
        <div className='w-2 h-2 rounded-full bg-orange-500' />
      ) : (
        <InfoIcon sx={{ fontSize: 14 }} />
      )}
      <span className='text-xs font-black uppercase tracking-tighter'>
        {text}
      </span>
    </div>
  );
};

export default ReturnStatusBadge;
